"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgFilterFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M8.002 4C6.45 4 5.49 5.696 6.288 7.029L9.505 13v5.027c.034.696.3 1.227.799 1.592.498.366 1.11.467 1.837.305l1.965-.66c.418-.156.74-.39.966-.701.226-.31.358-.71.398-1.196V13l3.182-5.971c.8-1.333-.16-3.029-1.714-3.029H8.002z' }))); };
exports.default = SvgFilterFilled;
//# sourceMappingURL=FilterFilled.js.map